import { INVALID_PARAMETER } from '../constants/api-error-enums';
import complianceSettings from '../schemas/dictionary/compliance-settings';
import constructValidationMessage from './construct-validation-message';

const validateComplianceSettings = data => {
  const { error } = complianceSettings.validate(data, {
    abortEarly: false,
    allowUnknown: true
  });

  let reason;
  if (error) {
    reason = INVALID_PARAMETER;
  }

  return constructValidationMessage(error, 'complianceSettings', reason);
};

export default validateComplianceSettings;
